import { useRef } from "react";
import PropTypes from "prop-types";
import useChatMentions from "./useChatMentions";
import ChatMentionDropdown from "./ChatMentionDropdown";
import "./chatMentions.scss";

const ChatComposerField = ({
  value,
  onChange,
  onKeyDown,
  mentionUsers = [],
  searchUsers,
  currentUserId,
  placeholder,
  className = "",
  id,
  name,
  rows,
}) => {
  const textareaRef = useRef(null);
  const mentions = useChatMentions({
    value,
    onChange,
    users: mentionUsers,
    textareaRef,
    searchUsers,
    currentUserId,
  });

  return (
    <div className="chat-composer-field">
      {mentions.open && (
        <ChatMentionDropdown
          users={mentions.filteredUsers}
          activeIndex={mentions.activeIndex}
          onSelect={mentions.selectUser}
        />
      )}
      <textarea
        ref={textareaRef}
        id={id}
        name={name}
        rows={rows}
        value={value}
        onChange={mentions.handleChange}
        onKeyDown={(e) => {
          if (mentions.handleKeyDown(e)) return;
          onKeyDown?.(e);
        }}
        className={className}
        placeholder={placeholder}
      />
    </div>
  );
};

ChatComposerField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  mentionUsers: PropTypes.array,
  searchUsers: PropTypes.func,
  currentUserId: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  rows: PropTypes.number,
};

export default ChatComposerField;
